<template>
  <Popup
    class="h5-login-modal"
    v-model:show="show"
    v-bind="$attrs"
    position="bottom"
  >
    <div class="h5-login-modal__header">
      <div class="h5-login-modal__title">
        My Account
      </div>
      <img
        src="@/assets/H5/offer/sourcing-close.svg"
        alt=""
        class="h5-login-modal__close"
        @click="close"
      >
    </div>
    <div class="h5-login-modal__content">
      <LoginContent @logged-in="onLogged" />
    </div>
  </Popup>
</template>

<script setup>
import Popup from '@/components/Popup/index.vue'
import { LoginContent, useLoginModal } from '@/components/Login'
import { buriedPointUtil } from '@/utils/utils'

defineOptions({
  inheritAttrs: false
})

const emit = defineEmits(['close'])

const { show, close } = useLoginModal()

watch(show, (val) => {
  if (val === false) {
    emit('close')
  } else {
    buriedPointUtil({ eventId: 'MPLG501' })
  }
})

const onLogged = () => {
  close()
}
</script>

<style lang="less">
.h5-login-modal {
  padding: 12px;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 12px;
    background-color: #FFFFFF;
    border-radius: 8px;

    font-family: mon-600;
    font-size: 14px;
  }

  &__content {
    flex: 1;
    background-color: #FFFFFF;
    border-radius: 8px;
    overflow: hidden;
  }
}
</style>
